import { Component, OnInit,ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';//para pasar datos de regreso desde aca del modal
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-acciones-locciones',
  templateUrl: './modal-acciones-locciones.component.html',
  styleUrls: ['./modal-acciones-locciones.component.scss']
})
export class ModalAccionesLoccionesComponent implements OnInit {

  usuario=null;
  procesodeEliminarActivo=false
  alertaActiva=false;
  tipodeAlerta='primary'
  mensajeAlerta=''
  trabajando=false
  regional=''
  nombre=''
  botondisabled=true

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  cerrar(parametro){
    this.activeModal.close(parametro);//esto no lo estamos usando pero es para tenerlo ahi 
  }

  confirmaEliminar(){
    this.procesodeEliminarActivo=true
  }
  cancelarEliminar(){
    this.procesodeEliminarActivo=false
  }

  eliminarCuenta(idParaEliminar){
    this.trabajando=true
    this.alerta("warning","eliminando locación...")

          //despues de eliminada la cuenta, se elimina de la coleccion de users y despues de la de autoridades
          firebase.firestore().collection("locaciones").doc(idParaEliminar).delete().then(()=>{
            
            this.procesodeEliminarActivo=false
              this.alerta("success","Locación eliminado con éxito!")
              this.cerrar("OK")
            
          }).catch((err)=>{
            this.alerta("danger",err)
            this.cerrar(err)
          })
  }

  closeAlert(){
    this.alertaActiva=false
  }
  
  
  alerta(tipo,input){
    this.alertaActiva=true;
    this.mensajeAlerta=input;
    this.tipodeAlerta=tipo;
  }

  validaboton(){
    console.log("validaboton activado")
      if( this.nombre !='' && this.regional !=''){this.botondisabled=false}else
      if( this.nombre =='' || this.regional ==''){this.botondisabled=true}
  }




}//fin de clase
